// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Md3P","col":"styles_col__3dYm1"};